<!--banner-->
<section class="hero" id="hero">
    <div class="container">
        <div class="content">
            <h3 class="animated-text">
                West Bengal State Rural Livelihoods Mission (WBSRLM) <br><span class="animate-pulse">–
                    Anandadhara</span>
            </h3>
        </div>
    </div>
</section>


<!--aboutus-->
<div class="about-us" id="about-us">
    <div class="container">
        <div class="row">
            <div class="col-lg-7">
                <h5 class="font-bold" style="color: #f49054;">About WBSRLM (Anandadhara)</h5>
                <p>
                    West Bengal State Rural Livelihoods Mission, popularly known as Anandadhara, is the State Rural
                    Livelihoods Mission of West Bengal. It functions under the framework of the National Rural
                    Livelihoods Mission (NRLM) with the core objective of reducing rural poverty through women-led
                    institutional platforms.
                </p>
                <h6 class="font-italic text-black">
                    The Mission works by:
                </h6>
                <ul class="ml-4">
                    <li>Organizing rural poor women into Self Help Groups (SHGs)</li>
                    <li>Federating SHGs into Sangha Samabays or Cluster Level Federations (CLFs)</li>
                    <li>Strengthening access to financial services</li>
                    <li>Promoting sustainable livelihoods</li>
                    <li>Enhancing social inclusion and gender empowerment</li>
                </ul>
                <p>
                    Anandadhara focuses on building strong community institutions that are self-reliant, transparent,
                    and sustainable.
                </p>
            </div>
            <div class="col-lg-5">
                <!-- <img src="../../../../../../assets/images/banner-1.jpg" alt="About Us" class="bt-img p-2 rounded-lg shadow-lg h-100 object-fit-cover"> -->
                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="7"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/1.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/2.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/3.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/4.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/5.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/6.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/7.JPG" alt="">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/9.JPG" alt="">
                        </div>
                    </div>
                    <!-- <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a> -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mission & Vision -->
<section class="mission-vision-section" id="mission-vision">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h5 class="text-black font-bold">Our Mission & Vision</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="mv-card mission-card p-4 rounded-lg shadow-md h-100 border-4 border-l-sky-600">
                    <h6 class="text-sky-700 font-bold">Mission of WBSRLM</h6>
                    <p>
                        To reduce poverty by enabling the poor households to access gainful self-employment and skilled
                        wage employment opportunities, resulting in appreciable improvement in their livelihoods on a
                        sustainable basis through strong institutional platforms of the poor.
                    </p>
                    <ul class="ml-4">
                        <li>Social mobilization and institution building</li>
                        <li>Financial inclusion</li>
                        <li>Livelihood promotion</li>
                        <li>Capacity enhancement</li>
                        <li>Convergence with government schemes</li>
                        <li>Women empowerment and social development</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mv-card vision-card p-4 rounded-lg shadow-md h-100 border-4 border-l-yellow-500">
                    <h6 class="text-yellow-600 font-bold">Vision of WBSRLM</h6>
                    <p>
                        To create a self-reliant, empowered, and economically secure rural society led by strong women
                        institutions.
                    </p>
                    <ul class="ml-4">
                        <li>Universal social mobilization</li>
                        <li>Sustainable livelihoods for every rural poor household</li>
                        <li>Financial independence of SHGs</li>
                        <li>Digitally empowered community institutions</li>
                        <li>Gender-equitable rural development</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="mission-vision-section bg-white">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h5 class="text-black font-bold">Training & Capacity Building (T&CB) under WBSRLM</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="mv-card mission-card p-4 rounded-lg shadow-md h-100 border-4 border-l-green-700">
                    <h6 class="text-green-700 font-bold">Importance of Training & Capacity Building</h6>
                    <p>
                        Training & Capacity Building is the backbone of WBSRLM. Since the Mission is based on
                        community-led development, strengthening knowledge, skills, and leadership among members is
                        essential.
                    </p>
                    <p class="text-black font-bold m-0">T&CB ensures:</p>
                    <ul class="ml-4">
                        <li>Institutional sustainability</li>
                        <li>Improved governance and transparency</li>
                        <li>Financial discipline</li>
                        <li>Enhanced livelihood productivity</li>
                        <li>Leadership development among rural women</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mv-card vision-card p-4 rounded-lg shadow-md h-100 border-4 border-l-blue-800">
                    <h6 class="text-blue-800 font-bold">Objectives of Training & Capacity Building</h6>
                    <ul class="ml-4">
                        <li>To enhance functional literacy and awareness among SHG members</li>
                        <li>To strengthen governance of SHGs, Sanghas, and CLFs</li>
                        <li>To build financial management skills</li>
                        <li>To promote entrepreneurship and livelihood diversification</li>
                        <li>To develop Community Resource Persons (CRPs)</li>
                        <li>To ensure effective implementation of Mission interventions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!--Major Areas of Training-->
<section class="mission-vision-section" id="training-areas">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h5 class="text-black font-bold">Major Areas of Training</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="mv-card1 mission-card p-4 rounded-lg shadow-md">
                    <h6 class="card-title1 text-sky-700 m-0">A. Social Mobilization & Institution Building</h6>
                    <ul class="ml-4">
                        <li>SHG concept and norms</li>
                        <li>Roles & responsibilities of office bearers</li>
                        <li>Meeting management</li>
                        <li>Bookkeeping practices</li>
                        <li>Federation management</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mv-card1 mission-card p-4 rounded-lg shadow-md">
                    <h6 class="card-title1 text-sky-700 m-0">B. Financial Inclusion & Management</h6>
                    <ul class="ml-4">
                        <li>Bank linkage process</li>
                        <li>Credit planning and loan management</li>
                        <li>Community Investment Fund (CIF) management</li>
                        <li>Vulnerability Reduction Fund (VRF) management</li>
                        <li>Financial literacy and digital transactions</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mv-card1 mission-card p-4 rounded-lg shadow-md">
                    <h6 class="card-title1 text-sky-700 m-0"> C. Livelihood Promotion, Convergence & Market Linkage</h6>
                    <ul class="ml-4">
                        <li>Farm-based livelihood enhancement</li>
                        <li>Non-farm enterprises promotion</li>
                        <li>Micro-enterprise development</li>
                        <li>Business planning and market linkage & Convergence</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mv-card1 mission-card p-4 rounded-lg shadow-md">
                    <h6 class="card-title1 text-sky-700 m-0">D. Skill Development</h6>
                    <ul class="ml-4">
                        <li>Vocational skill training</li>
                        <li>Value addition and processing</li>
                        <li>Packaging and branding</li>
                        <li>Quality control</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mv-card1 mission-card p-4 rounded-lg shadow-md">
                    <h6 class="card-title1 text-sky-700 m-0">E. Leadership & Social Development</h6>
                    <ul class="ml-4">
                        <li>Gender sensitization</li>
                        <li>Social action planning</li>
                        <li>Conflict resolution</li>
                        <li>Community leadership development</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!--Institutional Structure for T&CB-->
<section class="mission-vision-section bg-white">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="mv-card mission-card p-4 rounded-lg shadow-md h-100 border-4 border-l-lime-700">
                    <h6 class="text-lime-700 font-bold">Institutional Structure for T&CB</h6>

                    <p class="text-black font-bold m-0">Training is implemented through:</p>
                    <ul class="ml-4">
                        <li>State Mission Management Unit (SMMU)</li>
                        <li>District Mission Management Units (DMMU)</li>
                        <li>Block Mission Management Units (BMMU)</li>
                        <li>Community Managed Training Centres (CMTCs)</li>
                        <li>Community Resource Persons (CRPs)</li>
                        <li>External resource agencies</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mv-card vision-card p-4 rounded-lg shadow-md h-100 border-4 border-l-amber-800">
                    <h6 class="text-amber-800 font-bold">Expected Outcomes of T&CB</h6>
                    <ul class="ml-4">
                        <li>Strong and self-managed SHGs</li>
                        <li>Financially disciplined federations</li>
                        <li>Increased income and livelihood diversification</li>
                        <li>Enhanced participation of women in decision-making</li>
                        <li>Sustainable and accountable community institutions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!--Conclusion-->
<section class="mission-vision-section bg-white pt-1">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h5 class="text-black font-bold">Conclusion</h5>
                <p>
                    WBSRLM (Anandadhara) envisions a transformed rural society led by empowered women institutions.
                    Training & Capacity Building plays a pivotal role in achieving this transformation by equipping
                    rural women with the skills, knowledge, and confidence required to manage institutions and
                    livelihoods effectively.
                </p>
                <p>
                    Through structured capacity enhancement and institutional strengthening, Anandadhara continues to
                    move towards inclusive, sustainable, and women-led rural development in West Bengal.
                </p>
            </div>
        </div>
    </div>
</section>